import md5 from 'md5'
const secret = 'fcc31629e2f3a2b8ea001a59ef792113'
/**
 * 生成签名规则
 * 请求参数排序
 * a、加密规则根据参数名按照字母正序【a-z】的顺序信息排列拼接如:
 * b、只将id,page,limit,还有字段中包含_id的key才参与验证
 * a=l&c=2&b=6&s=l&time=10o&versions=o.o.1
 */
export const sortParams = (params) => {
    let auth = '';
    Object.keys(params).sort().forEach((item) => {
        // id,page,limit,versions,field中包含_id的key
        if (['id', 'page', 'limit'].includes(item) || item.includes('_id')) {
            auth += item + '=' + params[item] + '&'
        }
    })
    // 删除最后一个&
    // if(auth.length){
        auth = auth.substr(0, auth.length - 1);
        auth = md5(md5(auth) + secret);
        auth = auth.toUpperCase();
    // }
    return auth;
}
